import { useAuth } from "@clerk/clerk-react";
import { Button, CircularProgress, Grid } from "@mui/material";
import { AlertContext } from "contexts/Alert";
import { NewCampaignContext } from "contexts/NewCampaign";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";

import BrandCard from "features/Influencer/Discover/Results/BrandCard";
import { BrandCardSource } from "features/Influencer/Discover/Results/schema";
import { fetcherAuth } from "utils/api";

const PreviewCampaignBrands = () => {
  const { getToken } = useAuth();
  const { setErrorAlert } = useContext(AlertContext);
  const { currentOrg } = useContext(OrganizationUserContext);
  const { campaign, setCampaign } = useContext(NewCampaignContext);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchMoreCampaignBrands = async () => {
    if (!campaign?.id || !currentOrg?.id) return;
    setLoadMoreLoading(true);
    try {
      const nextPage = currentPage + 1;
      const { campaignBrands } = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg.id}/campaigns/${campaign.id}?per_page=10&page=${nextPage}`,
        "GET",
      );
      setCampaign((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          campaignBrands: [...(prev.campaignBrands ?? []), ...campaignBrands],
        };
      });
      setCurrentPage(nextPage);
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setLoadMoreLoading(false);
    }
  };

  if (!campaign) return <></>;

  return (
    <>
      {campaign?.campaignBrands &&
        campaign.campaignBrands.length > 0 &&
        (() => {
          const remaining =
            (campaign?.campaignBrandCount || 0) -
            campaign?.campaignBrands.length;
          return (
            <Grid container gap={2}>
              {campaign?.campaignBrands?.map((campaignBrand) => (
                <BrandCard
                  brand={campaignBrand?.bentoBrand}
                  source={BrandCardSource.CAMPAIGN_BRAND}
                />
              ))}
              {remaining > 0 && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    onClick={fetchMoreCampaignBrands}
                    disabled={loadMoreLoading}
                    sx={{ textTransform: "none", color: "purple.dark" }}
                  >
                    {loadMoreLoading ? (
                      <CircularProgress size={16} sx={{ mr: 1 }} />
                    ) : null}
                    Load more ({remaining} remaining)
                  </Button>
                </Grid>
              )}
            </Grid>
          );
        })()}
    </>
  );
};

export default PreviewCampaignBrands;
